<div class="overflow-hidden">
  <div class="row align-items-center">
    <div *ngIf="podemEditarSituacao() && !isRegistrarSituacaoEnabled()" class="col-12 col-md-auto mt-4">
      <bdg-alert type="warning">
        <bdg-label style="margin-left: -0.5em"> {{ labelAlertaRegistroSituacao }} </bdg-label>
      </bdg-alert>
    </div>
    <div *ngIf="podemEditarSituacao()" class="col-3 ml-auto mt-4 text-right">
      <bdg-button
        label="REGISTRAR SITUAÇÃO"
        (click)="onRegistrarSituacao()"
        matStyle="raised"
        matIcon="add"
        [disabled]="!isRegistrarSituacaoEnabled()"
      >
      </bdg-button>
    </div>
  </div>
  <div class="row mt-4">
    <div class="col-12">
      <div class="table residentes-table">
        <div
          *ngIf="isLoadingResults"
          class="w-100 border-bottom align-items-center d-flex justify-content-center white-background"
        >
          <mat-progress-bar color="accent" mode="indeterminate"></mat-progress-bar>
        </div>
        <mat-table #table [dataSource]="dataSource">
          <ng-container matColumnDef="dataCadastro">
            <mat-header-cell *matHeaderCellDef class="justify-content-end">Data de cadastro</mat-header-cell>
            <mat-cell [class.dark-secondary-text]="isLoadingResults" *matCellDef="let row" class="justify-content-end">
              <div class="mr-4">
                <mat-icon
                  color="warn"
                  matTooltip="Situação Desatualizada"
                  *ngIf="
                    this.isSituacaoResidenteDesatualizada(
                      row?.situacaoMatricula?.id,
                      row?.dataTermino,
                      row?.dataFinalizacao,
                      row.prorrogacaoLicencaMaternidade
                    )
                  "
                  >error</mat-icon
                >
              </div>
              <div>{{ row.dataCadastro | date: 'dd/MM/yy' }}</div>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="nomePrograma">
            <mat-header-cell *matHeaderCellDef class="pl-4">Programa</mat-header-cell>
            <mat-cell [class.dark-secondary-text]="isLoadingResults" *matCellDef="let row" class="pl-4">{{
              row.nomePrograma
            }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="anoResidencia">
            <mat-header-cell class="pr-4 pl-4 justify-content-start" *matHeaderCellDef>Ano</mat-header-cell>
            <mat-cell
              [class.dark-secondary-text]="isLoadingResults"
              class="pr-4 pl-4 justify-content-start"
              *matCellDef="let row"
              >{{ row?.anoResidencia?.descricao }}</mat-cell
            >
          </ng-container>

          <ng-container matColumnDef="situacaoMatricula">
            <mat-header-cell class="justify-content-center" *matHeaderCellDef> Situação </mat-header-cell>
            <mat-cell class="justify-content-center" *matCellDef="let row">
              <bdg-tag [accent]="isLoadingResults ? 'gray' : getSituacaoResidenteTag(row?.situacaoMatricula)">
                {{ row.situacaoMatricula.descricao }}
              </bdg-tag>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="dataOcorrencia">
            <mat-header-cell class="justify-content-end" *matHeaderCellDef>Data de ocorrência</mat-header-cell>
            <mat-cell [class.dark-secondary-text]="isLoadingResults" class="justify-content-end" *matCellDef="let row">
              {{ row.dataOcorrencia | date: 'dd/MM/yy' }}
              <mat-icon
                style="font-size: 18px; display: inline-block; vertical-align: middle"
                matTooltip="Situação iniciada no programa anterior"
                *ngIf="this.isSituacaoProgramaAnterior(row)"
                >info</mat-icon
              >
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="dataTermino">
            <mat-header-cell class="justify-content-end" *matHeaderCellDef>Data de término</mat-header-cell>
            <mat-cell
              [class.dark-secondary-text]="isLoadingResults"
              class="justify-content-end"
              *matCellDef="let row"
              >{{ row.dataTermino | date: 'dd/MM/yy' | infoLabel }}</mat-cell
            >
          </ng-container>

          <ng-container matColumnDef="dataFinalizacao">
            <mat-header-cell class="justify-content-end" *matHeaderCellDef>Data de finalização</mat-header-cell>
            <mat-cell
              [class.dark-secondary-text]="isLoadingResults"
              class="justify-content-end"
              *matCellDef="let row"
              >{{ row.dataFinalizacao | date: 'dd/MM/yy' | infoLabel }}</mat-cell
            >
          </ng-container>

          <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef class="pr-2 justify-content-end"></mat-header-cell>
            <mat-cell *matCellDef="let row; let i = index; first as isFirst" class="pr-2 justify-content-end">
              <bdg-menu [disabled]="isLoadingResults" *ngIf="podemEditarSituacao() && isFirst" icon="more_vert">
                <bdg-menu-item
                  label="Visualizar"
                  (itemClick)="onVisualizarSituacao(row.matriculaHistoricoId)"
                ></bdg-menu-item>
                <bdg-menu-item
                  label="Editar"
                  [disabled]="!canEdit(row)"
                  (itemClick)="onEditarSituacao(row.matriculaHistoricoId)"
                ></bdg-menu-item>
                <bdg-menu-item
                  [disabled]="!canFinalizar(row)"
                  label="Finalizar"
                  (itemClick)="onFinalizarSituacao(row.matriculaHistoricoId)"
                ></bdg-menu-item>
                <bdg-menu-item
                  label="Excluir"
                  *ngIf="canExcluir(row)"
                  (itemClick)="onExcluirSituacao(row)"
                ></bdg-menu-item>
              </bdg-menu>

              <bdg-icon-button
                icon="pageview"
                *ngIf="!podemEditarSituacao() || !isFirst"
                [disabled]="isLoadingResults"
                (click)="onVisualizarSituacao(row.matriculaHistoricoId)"
              >
              </bdg-icon-button>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        </mat-table>

        <div *ngIf="dataSource.data.length === 0 && !isLoadingResults" class="py-3 text-center border-bottom bg-white">
          <bdg-label color="rgba(0, 0, 0, 0.87); font-style: italic;">
            Nenhuma alteração de situação de matrícula encontrada.
          </bdg-label>
        </div>

        <mat-paginator
          [length]="resultsLength"
          class="mat-paginator-situacao"
          [pageSize]="10"
          [pageSizeOptions]="[5, 10, 25, 100]"
        ></mat-paginator>
      </div>
    </div>
  </div>
</div>
